/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { VersionType } from './versionType.model';


export interface ContractRelatedDto { 
    appendixNumber?: number;
    appendixSourceId?: number;
    endDate?: string;
    endType?: string;
    expirationDate?: string;
    groupId?: number;
    id?: number;
    owners?: Array<SubjectContactResponseDto>;
    resignDate?: string;
    signatureDate?: string;
    state?: string;
    successiveNextId?: number;
    successiveNumber?: number;
    successiveSourceId?: number;
    tenants?: Array<SubjectContactResponseDto>;
    versionType?: VersionType;
}
export namespace ContractRelatedDto {
}


